import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, type ConsentChoice } from "../../utils/cookieConsent";
import "./CookieBanner.css";

export const COOKIE_BANNER_EVENT = "aifp:openCookieSettings";

function CookieIcon() {
  return (
    <svg
      className="cookie-banner__icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="10" cy="10" r="8.25" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="7.2" cy="8.1" r="1.05" fill="currentColor" />
      <circle cx="11.6" cy="7.2" r="0.85" fill="currentColor" />
      <circle cx="9.1" cy="12.2" r="1.05" fill="currentColor" />
      <circle cx="13.2" cy="11.4" r="0.8" fill="currentColor" />
    </svg>
  );
}

export default function CookieBanner() {
  const [pending, setPending] = useState(() => getConsent() === null);
  const [reopened, setReopened] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    function reopenListener() {
      const saved = getConsent();
      if (saved) setMarketing(saved.marketing);
      setReopened(true);
      setShowCustomize(true);
    }
    window.addEventListener(COOKIE_BANNER_EVENT, reopenListener);
    return () => window.removeEventListener(COOKIE_BANNER_EVENT, reopenListener);
  }, []);

  function hide() {
    setPending(false);
    setReopened(false);
    setShowCustomize(false);
  }

  function save(choice: ConsentChoice, marketingChoice: boolean) {
    setConsent({ necessary: true, marketing: marketingChoice, choice });
    hide();
  }

  if (!pending && !reopened) return null;

  return (
    <div
      className="cookie-banner"
      role="region"
      aria-label="Consimțământ cookie-uri"
      data-testid="cookie-banner"
    >
      {!showCustomize ? (
        <div className="cookie-banner__inner">
          <div className="cookie-banner__copy">
            <CookieIcon />
            <p className="cookie-banner__text">
              Folosim cookie-uri necesare pentru funcționarea site-ului și, cu acordul tău, Meta
              Pixel pentru măsurarea campaniilor publicitare și statistici.{" "}
              <Link to="/politica-de-confidentialitate">Politica de confidențialitate</Link>
            </p>
          </div>

          <div className="cookie-banner__actions">
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--prefs"
              onClick={() => setShowCustomize(true)}
            >
              Preferințe
            </button>
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--reject"
              onClick={() => save("rejected", false)}
            >
              Refuză
            </button>
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--accept"
              onClick={() => save("accepted", true)}
            >
              Acceptă toate
            </button>
          </div>
        </div>
      ) : (
        <div className="cookie-banner__inner cookie-banner__inner--prefs">
          <div className="cookie-banner__customize">
            <div className="cookie-banner__option">
              <input type="checkbox" id="cb-necessary" checked disabled />
              <label htmlFor="cb-necessary">
                <strong>Necesare</strong> — funcționarea site-ului și autentificarea (obligatorii)
              </label>
            </div>
            <div className="cookie-banner__option">
              <input
                type="checkbox"
                id="cb-marketing"
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
              />
              <label htmlFor="cb-marketing">
                <strong>Marketing</strong> — Meta Pixel, pentru măsurarea campaniilor publicitare
              </label>
            </div>
          </div>

          <div className="cookie-banner__save-row">
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--prefs"
              onClick={() => setShowCustomize(false)}
            >
              Înapoi
            </button>
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--accept"
              onClick={() => save("custom", marketing)}
            >
              Salvează
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
